import { MapToContext } from '@utils/objectWithDefault'
import PaginationModel from '@models/pagination'
import { DestinationCountry } from '@models/pricing/destinationCountries'

export class ZonePrice {
  constructor (zonePriceData) {
    const defaultZonePriceData = {
      zoneId: { val: 0, type: Number },
      price: { val: 0, type: Number },
      currencyCode: { val: '', type: String }
    }

    MapToContext(this, defaultZonePriceData, zonePriceData)
  }
}

export class PricingRate {
  constructor (pricingItemData) {
    const defaultPricingItem = {
      weightOunceStart: { val: 0, type: Number },
      weightOunceEnd: { val: 0, type: Number },
      zonePrices: { val: [], type: Array, subType: ZonePrice }
    }

    MapToContext(this, defaultPricingItem, pricingItemData)
  }
}

export default class PricingPlan {
  constructor (pricingPlanData) {
    const defaultPricingPlan = {
      pagination: { val: {}, type: Object },
      pricingRates: { val: [], type: Array, subType: PricingRate },
      destinations: { val: [], type: Array, subType: DestinationCountry }
    }

    MapToContext(this, defaultPricingPlan, pricingPlanData)
    this.pagination = new PaginationModel(this.pagination)
  }
}
